import { FC, Fragment, useMemo, useState } from "react";
import { GridApi } from "ag-grid-community";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { useAppSelector } from "@/store/hooks";
import {
  dimensionsAutoGroupColumnDef,
  getDimensionsGridColDefs,
} from "@/components/pages/dimensions/components/data-grid/dimensions/dimensionsGridColDefs";
import { dimensionsGridDataSelector } from "@/store/dimensions/selectors/dimensions-data/dimensionsGridDataSelector";
import { categoriesByDimensionIdMapSelector } from "@/store/dimensions/selectors/dimensions-data/categoriesByDimensionIdMapSelector";
import { DimensionsAgGridToolbar } from "@/components/pages/dimensions/components/data-grid/dimensions/DimensionsAgGridToolbar";
import {
  dimensionGridDefaultColDef,
  dimensionGridIcons,
  dimensionGridWrapperStyles,
  dimensionsConfigToRememberStateInStorage,
  getDimensionsRowClass,
} from "@/components/pages/dimensions/components/data-grid/dimensions/utils/constants/gridConstants";
import { dimensionsLoadingSelector } from "@/store/dimensions/selectors/dimensions-data/dimensionsLoadingSelector";

export const DimensionsDataGrid: FC = () => {
  const data = useAppSelector(dimensionsGridDataSelector);
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const loading = useAppSelector(dimensionsLoadingSelector);
  const categoriesByDimensionIdMap = useAppSelector(
    categoriesByDimensionIdMapSelector,
  );

  const columnDefs = useMemo(
    () => getDimensionsGridColDefs(categoriesByDimensionIdMap),
    [categoriesByDimensionIdMap],
  );

  return (
    <Fragment>
      <DimensionsAgGridToolbar gridApi={gridApi} />
      <AgDataGrid
        rowData={data}
        rowHeight={52}
        treeData={true}
        loading={loading}
        headerHeight={52}
        groupTotalRow="bottom"
        grandTotalRow="bottom"
        columnDefs={columnDefs}
        gridApiSetter={setGridApi}
        icons={dimensionGridIcons}
        suppressStickyTotalRow="group"
        treeDataChildrenField="children"
        getRowClass={getDimensionsRowClass}
        defaultColDef={dimensionGridDefaultColDef}
        wrapperStyles={dimensionGridWrapperStyles}
        autoGroupColumnDef={dimensionsAutoGroupColumnDef}
        configToRememberStateInStorage={
          dimensionsConfigToRememberStateInStorage
        }
      />
    </Fragment>
  );
};
